module.exports = __webpack_public_path__ + "img/brand14.68473790.png";